import { z } from "zod";
import { Id, NonEmpty, Url } from "./base";
import { TimestampInputSchema } from "./epoch";
import { BadgeTierSchema } from "./user/badge";
import { QuestSubmissionStatusSchema } from "./community/campaign/quest";
import { notificationTypeValues } from "./constant_values";
export const NotificationTypeSchema = z.enum(notificationTypeValues);
export const NotificationMetadataSchema = z
    .object({
    questId: Id.optional(),
    communityId: Id.optional(),
    communityName: z.string().optional(),
    referralName: z.string().optional(),
    rewardType: z.string().optional(), // TODO: tighten type once reward model is finalized
    questTitle: z.string().optional(),
    campaignName: z.string().optional(),
    feedback: z.string().optional(),
    submissionId: Id.optional(),
    status: QuestSubmissionStatusSchema.optional(),
    badgeTier: BadgeTierSchema.optional(),
    oldBadge: BadgeTierSchema.optional(),
    newBadge: BadgeTierSchema.optional(),
    prizeAmount: z.string().optional(),
    isRaffleWinner: z.boolean().optional(),
    campaignId: Id.optional(),
    blocksEarned: z.number().optional(),
    leaderboardId: Id.optional(),
})
    .optional();
export const NotificationSchema = z.object({
    id: Id,
    type: NotificationTypeSchema,
    title: NonEmpty,
    message: NonEmpty,
    timestamp: TimestampInputSchema.optional(),
    read: z.boolean().default(false),
    actionUrl: Url.max(1024).optional(),
    userId: Id,
    metadata: NotificationMetadataSchema,
});
export const NotificationRecordSchema = NotificationSchema.extend({
    createdAt: TimestampInputSchema,
    updatedAt: TimestampInputSchema,
    readAt: TimestampInputSchema.optional(),
    deletedAt: TimestampInputSchema.optional(),
});
export const NotificationCreateInputSchema = z.object({
    type: NotificationTypeSchema,
    title: NonEmpty,
    message: NonEmpty,
    actionUrl: Url.max(1024).optional(),
    metadata: NotificationMetadataSchema,
    timestamp: TimestampInputSchema.optional(),
});
export const NotificationReadInputSchema = z.object({
    read: z.literal(true),
});
